export default __webpack_public_path__ + "102b7b4861c0fbf6f700de4207839ddf.svg";